import { combineReducers } from 'redux';
import {
    RECEIVE_ACCOUNT_MESSAGES,
    REQUEST_ACCOUNT_MESSAGES,
    FAILURE_ACCOUNT_MESSAGES
} from './constants';
import { RESET_ACCOUNT_USER } from '../constants';

/*
 * State shape
{
    messages : [],
    fetching: false,
    error: ''
}
*/

const messages = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_ACCOUNT_MESSAGES:
            return action.response.payload;
        case RESET_ACCOUNT_USER:
            return [];
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_ACCOUNT_MESSAGES:
            return true;
        case FAILURE_ACCOUNT_MESSAGES:
        case RECEIVE_ACCOUNT_MESSAGES:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_ACCOUNT_MESSAGES:
            return action.response.message;
        case REQUEST_ACCOUNT_MESSAGES:
        case RECEIVE_ACCOUNT_MESSAGES:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    messages,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/account/mymessages/reducer.js